import { AJOObject } from 'mp-js-react-auto-json-object';
import { Link } from 'react-router-dom';
import { AccordeonTable } from '../../component/AccordeonTable';
import { DoubleDateModal } from '../../modal/vendor/DoubleDateModal';
import { Comptable } from '../../object/Comptable';
import { Marge } from '../../object/Marge';
import { MargeReduc } from '../../object/marge_reduc/MargeReduc';
import { EuroSpan } from '../component/EuroSpan';
import { Col } from '../table/Col';
import Table from '../table/Table';

export class PrixVenteCol<Type extends AJOObject> extends Col<Type> {
    bonusRender: (children: JSX.Element, elem: Type | undefined) => JSX.Element = (elem) => elem;
    get: (elem: Type) => AJOObject = (elem) => elem;
    constructor(table: Table<Type>, get: (elem: Type) => AJOObject = (elem) => elem, name: string = 'PV HT') {
        super(name);
        this.sumRender = (list: Type[]) => {
            let sum = 0;
            for (let elem of list) {
                if ('Comptable' in get(elem)) {
                    let inter = get(elem) as unknown as Comptable;
                    sum += inter.prixVenteHT();
                } else if (get(elem) instanceof MargeReduc) {
                } else {
                    throw new Error('Comptable not found in elem');
                }
            }
            return <EuroSpan value={sum} />;
        };

        this.render = (elem: Type) => {
            if ('Comptable' in get(elem)) {
                let inter = get(elem) as unknown as Comptable;
                let res;
                res = this.bonusRender(<EuroSpan value={inter.prixVenteHT()} />, elem);
                return res;
            } else {
                throw new Error('Comptable not found in elem');
            }
        };
        this.sort = (a: Type, b: Type) => {
            if ('Comptable' in get(a) && 'Comptable' in get(b)) {
                let aInter = get(a) as unknown as Comptable;
                let bInter = get(b) as unknown as Comptable;
                if (isNaN(bInter.prixVenteHT())) {
                    return -1;
                } else if (isNaN(aInter.prixVenteHT())) {
                    return 1;
                } else {
                    return bInter.prixVenteHT() - aInter.prixVenteHT();
                }
            } else {
                throw new Error('Comptable not found in a or b');
            }
        };
        this.type = 'sort';
        this.typeRender = 'stat';
        this.senseSort = 0;
        this.table = table;
    }
}
